/*
 * @Author: cmchiu
 * @Date: 2023-03-21 16:44:24
 * @LastEditTime: 2023-05-23 17:50:13
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \IACMP\IACMP_Client\src\api\common.js
 *
 */
import request from '@/utils/request'

export const getParaLs = params => {
    return request({
        url: '/Common/GetParamsLs',
        method: 'get',
        params,
        withCredentials: true,
    })
}

export const getMenu = params => {
    return request({
        url: '/Portal/GetMenu',
        method: 'get',
        params,
        withCredentials: true,
    })
}

export const getPagePath = params => {
    return request({
        url: '/Portal/GetPagePath',
        method: 'get',
        params,
        withCredentials: true,
    })
}

export const getItemContent = data => {
    return request({
        url: '/Portal/GetItemContent',
        method: 'post',
        data,
        withCredentials: true,
    })
}
